module.exports = __webpack_public_path__ + "static/media/ARE.bcb6df80.svg";